/** @jsx jsx */
import { jsx, Box } from "theme-ui"
import { Participant as ParticipantType } from "../../types"
import { Participant } from "../Participant"
import * as styles from "./styles"
import React from "react"

interface ParticipantsProps {
  participants: ParticipantType[]
}

export const Participants: React.FC<ParticipantsProps> = ({ participants }) => {
  return (
    participants && (
      <Box as="ul" sx={styles.root}>
        {participants.map(participant => {
          const { user, role } = participant
          if (role && role.id === 1) {
            return (
              <li key={user.id}>
                <Participant participant={participant} />
              </li>
            )
          }
        })}
      </Box>
    )
  )
}
